import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import HomeLayout from "src/layouts/HomeLayout";
import LoginLayout from "src/layouts/LoginLayout";
import Onboard from "src/layouts/Onboard";
import DashboardLayout from "src/layouts/DashboardLayout/Index";
import Assest from "src/layouts/Assets/index";
import AccountantLayout from "src/layouts/Accountant/index";
import ProfileDashboardLayout from "src/layouts/Profile/index";
import SignUpLayout from "src/layouts/SignUpLayout/index";
import LoginRedirectGuard from "src/guards/LoginRedirectGuard";
import OnboardingGuard from "src/guards/OnboardingGuard";

export const routes = [
  {
    exact: true,
    path: "/",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Home/LandingPage/Index")),
  },
  {
    exact: true,
    path: "/pricing",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Pricing/Index")),
  },
  {
    exact: true,
    path: "/features",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Features/FeaturesIndex")),
  },
  {
    exact: true,
    path: "/how-it-works",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/HowItWorks/Index")),
  },
  {
    exact: true,
    path: "/for-accountants",
    layout: HomeLayout,
    component: lazy(() => import("src/views/pages/ForAccountants/Index")),
  },
  {
    exact: true,
    path: "/secure/login",
    layout: SignUpLayout,
    guard: LoginRedirectGuard,
    component: lazy(() => import("src/views/pages/Auth/Login/Index")),
  },
  {
    exact: true,
    path: "/secure/get-started",
    layout: SignUpLayout,
    guard: LoginRedirectGuard,
    component: lazy(() => import("src/views/pages/Auth/Login/GetStarted")),
  },
  {
    exact: true,
    path: "/secure/signup",
    layout: SignUpLayout,
    guard: LoginRedirectGuard,
    component: lazy(() => import("src/views/pages/Auth/Login/SignUp")),
  },
  {
    // Same SignUp form/component as /secure/signup - SignUp.js checks its own pathname and
    // activates the CPA portal for the new account right after creation when it's this route.
    exact: true,
    path: "/secure/accountant-signup",
    layout: SignUpLayout,
    guard: LoginRedirectGuard,
    component: lazy(() => import("src/views/pages/Auth/Login/SignUp")),
  },
  {
    // Same Login form/component as /secure/login - Index.js checks its own pathname and
    // routes straight to the CPA portal after sign-in instead of the regular portfolio flow.
    exact: true,
    path: "/secure/accountant-login",
    layout: SignUpLayout,
    guard: LoginRedirectGuard,
    component: lazy(() => import("src/views/pages/Auth/Login/Index")),
  },
  {
    // guard: true,
    exact: true,
    path: "/secure/verify-mail",
    layout: LoginLayout,
    component: lazy(() => import("src/views/pages/Auth/Login/VerifyMail")),
  },
  {
    exact: true,
    path: "/secure/recover-password",
    layout: LoginLayout,
    component: lazy(() => import("src/views/pages/Auth/Login/RecoverPassword")),
  },
  {
    exact: true,
    path: "/secure/recover-password-mail",
    layout: LoginLayout,
    component: lazy(() =>
      import("src/views/pages/Auth/Login/PasswordRecovery")
    ),
  },
  {
    exact: true,
    path: "/secure/create-new-password",
    layout: LoginLayout,
    component: lazy(() =>
      import("src/views/pages/Auth/Login/CreateNewPassword")
    ),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/select-country",
    layout: Onboard,
    component: lazy(() => import("src/views/pages/Auth/Login/Onboard/Index")),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/add-assets",
    layout: Assest,
    component: lazy(() => import("src/views/assest/index")),
  },
  // Below is the Hotfix route to account for COINBASE disabling the redirect URL, need to remove once COINBASE issue is resoved from their end.
  {
    guard: true,
    exact: true,
    path: "/add-assets",
    layout: Assest,
    component: lazy(() => import("src/views/assest/index")),
  },
  // Below is the Hotfix route to account for COINBASE disabling the redirect URL, need to remove once COINBASE issue is resoved from their end.
  {
    guard: true,
    exact: true,
    path: "/secure/add-assets",
    layout: Assest,
    component: lazy(() => import("src/views/assest/index")),
  },
  // Below is the Hotfix route to account for COINBASE disabling the redirect URL, need to remove once COINBASE issue is resoved from their end.
  {
    guard: true,
    exact: true,
    path: "/add-assets",
    layout: Assest,
    component: lazy(() => import("src/views/assest/index")),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/add-wallet",
    layout: Assest,
    component: lazy(() => import("src/views/assest/AddAssest")),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/portfolio",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Portfolio/Index")),
  },
  // {
  //   guard: true,
  //   exact: true,
  //   path: '/vote',
  //   layout: Assest,
  //   component: lazy(() => import('src/views/pages/Portfolio/vote/index')),
  // },
  {
    guard: true,
    exact: true,
    path: "/secure/voter-list",
    layout: Assest,
    component: lazy(() =>
      import("src/views/pages/Portfolio/vote/VoterListpage")
    ),
  },
  {
    exact: true,
    guard: true,
    path: "/secure/profile",
    layout: ProfileDashboardLayout,
    component: lazy(() => import("src/views/pages/Profile/index")),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/airdrop-details",
    layout: Assest,
    component: lazy(() => import("src/views/pages/Airdrop/Detail/index")),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/transactions",
    layout: Assest,
    component: lazy(() =>
      import("src/views/pages/Transaction/components/Index")
    ),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/needs-review",
    layout: Assest,
    component: lazy(() => import("src/views/pages/TransferReview/index")),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/wallet",
    layout: Assest,
    component: lazy(() => import("src/views/pages/Wallet")),
  },
  {
    guard: true,
    exact: true,
    path: "/secure/my-wallet-addresses",
    layout: Assest,
    component: lazy(() => import("src/views/pages/KnownWalletsSection")),
  },
  // {
  //   exact: true,
  //   path: '/social',
  //   layout: Social,
  //   component: lazy(() => import('src/views/pages/Social/index')),
  // },
  // {
  //   exact: true,
  //   path: '/social-detail',
  //   layout: Social,
  //   component: lazy(() => import('src/views/pages/Social/Detail/index')),
  // },
  // {
  //   exact: true,
  //   path: '/ddd',
  //   layout: Assest,
  //   component: lazy(() => import('src/views/pages/Social/Detail/Slider')),
  // },
  {
    exact: true,
    path: "/secure/performance",
    layout: Assest,
    component: lazy(() => import("src/views/pages/Performance/Main")),
  },
  {
    exact: true,
    path: "/secure/tax-write-offs",
    layout: Assest,
    component: lazy(() => import("src/views/pages/TaxWriteOffs")),
  },
  {
    exact: true,
    path: "/secure/accountant",
    layout: AccountantLayout,
    component: lazy(() => import("src/views/pages/Accountant/index")),
  },
  {
    // Client-facing side, in the regular app layout (not AccountantLayout) - any regular user
    // can have an accountant invite them, whether or not they're an accountant themselves.
    guard: true,
    exact: true,
    path: "/secure/my-accountants",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Accountant/MyAccess")),
  },
  {
    exact: true,
    path: "/secure/accountant/clients/new",
    layout: AccountantLayout,
    component: lazy(() => import("src/views/pages/Accountant/AddClient")),
  },
  {
    exact: true,
    path: "/secure/accountant/clients/:clientUserId/tax",
    layout: AccountantLayout,
    component: lazy(() => import("src/views/pages/Accountant/ClientTaxSummary")),
  },
  {
    // Deliberately no guard - this has to work for someone who isn't logged in yet (that's the
    // whole point of a shareable invite link), see InviteLanding.js for how it branches.
    exact: true,
    path: "/secure/accountant/invite/:linkId",
    layout: AccountantLayout,
    component: lazy(() => import("src/views/pages/Accountant/InviteLanding")),
  },

  // {
  //   exact: true,
  //   path: '/dashboard',
  //   layout: Assest,
  //   component: lazy(() => import('src/views/pages/Dashboard/Index')),
  // },
{
  exact: true,
  path: "/secure/tax",
  layout: Assest,
  component: lazy(() => import("src/views/pages/Tax/TaxRouter")),
},
  {
    exact: true,
    path: "/secure/onBoarding",
    layout: Onboard,
    guard: OnboardingGuard,
    component: lazy(() => import("src/views/onBoarding")),
  },
  {
    exact: true,
    path: "/secure/payment-processing",
    component: lazy(() => import("src/views/pages/Payment/paymentProcessing")),
  },
  {
    exact: true,
    path: "/secure/payment-cancelled",
    component: lazy(() => import("src/views/pages/Payment/paymentCancelled")),
  },
  {
    exact: true,
    layout: HomeLayout,
    path: "/secure/404",
    component: lazy(() => import("src/views/errors/NotFound")),
  },

  {
    component: () => <Redirect to="/secure/404" />,
  },
];
